import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static values = { url: String };

  //モーダル表示
  modalShow(e) {
    var target = $(e.currentTarget).attr("data-target");
    var targetModal = document.querySelector(target);
    $(target).fadeIn(300);
    targetModal.showModal();
    targetModal.classList.add("is-open");
    this.htmlFix();
  }

  // ESCキーを押したときの処理を無効化し、modalClose()を発火
  keydown(e) {
    //プレビュー中は閉じない
    if ($(this).hasClass("is-initial-open") && e.key === "Escape") {
      e.preventDefault(); // デフォルトのESCキー処理を無効化
      return;
    } else if ($(this).hasClass("is-open") && e.key === "Escape") {
      e.preventDefault(); // デフォルトのESCキー処理を無効化
      this.modalClose();
    }
  }

  //オーバーレイクリックで閉じる
  overlay(e) {
    var target = $(e.target);
    if (!target.closest(".js-modal-content").length) {
      this.modalClose();
    }
  }

  //モーダル閉じる処理
  modalClose() {
    var openModal = document.querySelector(".js-modal.is-open");

    if (openModal) {
      window.location.href = this.urlValue;
      this.htmlScroll();
    }
  }

  //PC時のみ表示のモーダル、リサイズ時の処理
  resize() {
    var windowWidth = $(window).width();
    if (windowWidth < 768 && $(".js-modal").hasClass("only-pc")) {
      this.modalClose();
    }
  }

  //スクロール禁止状態にする
  htmlFix() {
    var st = $(window).scrollTop() * -1;
    $("html").addClass("is-fixed");
    $("body").css("top", st);
  }

  //スクロール禁止状態を解除する
  htmlScroll() {
    var st = parseFloat($("body").css("top")) * -1;
    $("html").removeClass("is-fixed").scrollTop(st);
    $("body").removeAttr("style");
  }
}
